import React, { Component } from 'react'
import { Icon, Table } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';

import { get_asset } from './../actions/print.action';

// Styles
import './../style.css';

class AssetPrint extends Component {

    constructor( props ){
        super( props );

        this.state = {
             data: []
        }

    }

    componentWillMount(){
        this.props.get_asset( this.props.match.params.id );

    }

    componentWillReceiveProps( nextProps ){
        
        if( nextProps.print.length != 0 ){
            this.setState({
                data: nextProps.print.OUTPUT.DATA[0]
            })

            setTimeout(() => {
                window.print();
            },500)

        }

    }

    render() {
        return (
            <div className="print_wrapper assets">
                
                <table width="100%">

                    <thead>
                        <tr>
                            <th colSpan="2">
                                <span className="print_logo"></span>
                                <span className="jgroup_logo"></span>
                            </th>
                        </tr>
                    </thead>

                    <tbody>

                        <tr>
                            <td colSpan="2">

                                <table width="100%">
                                    <tbody>
                                    <tr>
                                        <td style={{ borderBottom: 'solid 1px #999',fontSize: 30, textAlign: 'center', height: '65px', lineHeight: '65px' }}>
                                            ACKNOWLEDGEMENT FORM
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>

                        <tr><td style={{ height: '30px' }}></td></tr>

                        <tr>
                            <td colSpan="2">

                                <table width="100%">
                                    <tbody>
                                    <tr>
                                        <td style={{ height: '40px', lineHeight: '40px', width: '200px', fontSize: '18px', fontWeight: 'bold', color: '#73879C' }}>Employee Name: </td>
                                        <td style={{ fontSize: '18px' }}>{ this.state.data.full_name }</td>
                                    </tr>
                                    <tr>
                                        <td style={{ height: '40px', lineHeight: '40px', width: '200px', fontSize: '18px', fontWeight: 'bold', color: '#73879C' }}>Position: </td>
                                        <td style={{ fontSize: '18px' }}>{ this.state.data.designation_name }</td>
                                    </tr>
                                    <tr>
                                        <td style={{ height: '40px', lineHeight: '40px', width: '200px', fontSize: '18px', fontWeight: 'bold', color: '#73879C' }}>Department: </td>
                                        <td style={{ fontSize: '18px' }}>{ this.state.data.department_name }</td>
                                    </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>

                        <tr><td style={{ height: '30px' }}></td></tr>
                        <tr><td style={{ height: '30px' }}></td></tr>

                        <tr>
                            <td colSpan="2">

                                <table width="100%">
                                    <tbody>
                                    <tr>
                                        <td style={{ fontSize: '20px', height: '40px', lineHeight: '40px' }}>Device / Item Details:</td>
                                    </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>

                        <tr>
                            <td colSpan="2">

                                <table width="100%" border="1" style={{ border: 'solid 1px #000' }}>
                                    <tbody>
                                    <tr>
                                        <td style={{ padding: 10,fontSize: 16, width: '20%', fontWeight: 500, color: '#73879C' }}>Device Type / Item:</td>
                                        <td style={{ padding: 10,fontSize: 16 }}>{ this.state.data.asset_type }</td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: 10,fontSize: 16, width: '20%', fontWeight: 500, color: '#73879C' }}>Device Model:</td>
                                        <td style={{ padding: 10,fontSize: 16 }}>{ this.state.data.asset_model }</td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: 10,fontSize: 16, width: '20%', fontWeight: 500, color: '#73879C' }}>Device ID:</td>
                                        <td style={{ padding: 10,fontSize: 16 }}>{ this.state.data.asset_serial }</td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: 10,fontSize: 16, width: '20%', fontWeight: 500, color: '#73879C' }}>Remarks:</td>
                                        <td style={{ padding: 10,fontSize: 16 }}>{ this.state.data.notes }</td>
                                    </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>

                        <tr><td style={{ height: '30px' }}></td></tr>
                        <tr><td style={{ height: '30px' }}></td></tr>

                        <tr>
                            <td colSpan="2">

                                <table width="100%">
                                    <tbody>
                                    <tr>
                                        <td>
                                            <p style={{ fontSize: '18px' }}>
                                            By signing this form, I agree to the following: I am responsible for the equipment or 
                                            property issued to me; I will use it in the manner intended; I will be responsible for 
                                            any damage done; upon separation from the Company, I will return the item issued  in 
                                            proper working order and I authorize a deduction in my Final Settlement to cover the 
                                            replacement cost of any item  that is not returned for whatever reason, or is not 
                                            returned in good working order.</p>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>

                        <tr><td style={{ height: '30px' }}></td></tr>
                        <tr><td style={{ height: '30px' }}></td></tr>

                    </tbody>

                    <tfoot>
                        <tr>

                            <td>
                                <table width="100%">
                                    <tbody>
                                    <tr>
                                        <td style={{ fontSize: '18px', fontWeight: 500, color: '#73879C' }}>Acknowledged By:</td>
                                    </tr>
                                    <tr><td>&nbsp;</td></tr>
                                    <tr><td>&nbsp;</td></tr>
                                    <tr>
                                        <td style={{ width: '200px', fontSize: '18px', fontWeight: 500, height: '50px', lineHeight: '50px', color: '#73879C' }}>Signature:</td>
                                        <td>_______________________________</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '200px', fontSize: '18px', fontWeight: 500, height: '50px', lineHeight: '50px', color: '#73879C' }}>Name:</td>
                                        <td style={{fontSize: '18px'}}>{ this.state.data.full_name }</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '200px', fontSize: '18px', fontWeight: 500, height: '50px', lineHeight: '50px', color: '#73879C' }}>Date:</td>
                                        <td style={{fontSize: '18px'}}>{ this.state.data.date_given }</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                            <td>
                                <table width="100%">
                                    <tbody>
                                    <tr>
                                        <td style={{ fontSize: '18px', fontWeight: 500, color: '#73879C' }}>Handed Over By:</td>
                                    </tr>
                                    <tr><td>&nbsp;</td></tr>
                                    <tr><td>&nbsp;</td></tr>
                                    <tr>
                                        <td style={{ width: '200px', fontSize: '18px', fontWeight: 500, height: '50px', lineHeight: '50px', color: '#73879C' }}>Signature:</td>
                                        <td>_______________________________</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '200px', fontSize: '18px', fontWeight: 500, height: '50px', lineHeight: '50px', color: '#73879C' }}>Name:</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '200px', fontSize: '18px', fontWeight: 500, height: '50px', lineHeight: '50px', color: '#73879C' }}>Date:</td>
                                        <td></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>

                        </tr>
                    </tfoot>

                </table>


            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        print: state.print
    }
}

export default connect( mapStatetoProps, { get_asset } )( AssetPrint );



// WEBPACK FOOTER //
// ./src/pages/prints/asset/index.js